<template>
	<div class="overlay-container" v-if="$vuetify.breakpoint.smAndDown">
		<v-overlay v-if="dialog" :z-index="10010" class="upgrade-overlay-mobile">
			<v-row class="align-center justify-center">
				<v-col cols="12" md="8" class="text-center pa-4">
					<h5 class="text-black">
						<a @click.prevent="upgrade()">Upgrade</a>
						your subscription to access all features.
					</h5>
				</v-col>
			</v-row>
		</v-overlay>
		<v-btn v-show="dialog" icon @click="close" class="close-button" color="black">
			<v-icon>icon-close-large</v-icon>
		</v-btn>
	</div>
	<div v-else>
		<Dialog :dialogVisible="dialog" :isAngry="true" :removeCancelButton="true" @cancel="close" @agree="close">
			<template v-slot:dialog-header>
				<h4 v-if="isTrialCCNow">
					Start Your Free Trial
					<v-btn icon @click="close">
						<v-icon>icon-close-medium</v-icon>
					</v-btn>
				</h4>
				<h4 v-else>Upgrade to Access</h4>
			</template>
			<template v-slot:dialog-body>
				<div v-if="isTrialCCNow">
					<p class="upgrade-message" v-if="canUpdateOrg">
						This is a premium feature. <a @click.prevent="upgrade()">Select your plan</a> to start
						your free trial and get access to this feature.
					</p>
					<p class="upgrade-message" v-else>
						This is a premium feature. Contact an administrator to select your plan to start your free trial
						and get access to this feature.
					</p>
				</div>
				<div v-else>
					<p class="upgrade-message" v-if="!canUpdateOrg">
						This is a premium feature. Contact an administrator to upgrade your subscription to access all
						features.
					</p>
					<p class="upgrade-message" v-else-if="trialExpired && !subscription.hasPaymentMethod">
						Your free trial has ended. <a @click.prevent="upgrade()">Add a payment method</a>
						to continue using premium features.
					</p>
					<p class="upgrade-message" v-else-if="trialExpired">
						Your free trial has ended. Your account needs attention. Please access your subscription info in
						the <a @click.prevent="upgrade()">customer billing portal.</a>
					</p>
					<p class="upgrade-message" v-else-if="trialDaysRemaining > 0 && !subscription.hasPaymentMethod">
						{{ trialDays }} remaining on your free trial.
						<a @click.prevent="upgrade()">Add a payment method</a>
						to continue using once your trial is finished.
					</p>
					<p class="upgrade-message" v-else-if="trialDaysRemaining > 0 && subscription.hasPaymentMethod">
						{{ trialDays }} remaining on your free trial. At the end of your trial, we will automatically
						charge the card on file.
					</p>
				</div>
			</template>
		</Dialog>
	</div>
</template>

<script>
	import Account from "../api/account";
	import api from "@/api";
	import constants from "@/api/constants";

	export default {
		data() {
			return {
				dialog: false,
				organizationId: null,
				canUpdateOrg: false,
				isTrialCCNow: false,
				subscription: null,
				userEmail: null,
				trialDaysRemaining: null,
			};
		},
		methods: {
			async open(organization) {
				this.dialog = true;
				const me = await api.getMe();
				const account = new Account(me.account);
				this.canUpdateOrg = account.hasPermissionTo("UPDATE_ORGANIZATION");
				this.organizationId = organization.id;
				this.isTrialCCNow = organization.isTrialCCNow;
				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
			},
			setSubscriptionInfo(subscription, userEmail, trialDaysRemaining) {
				this.subscription = subscription;
				this.userEmail = userEmail;
				this.trialDaysRemaining = trialDaysRemaining;
			},
			close() {
				if (this.resolve) {
					this.resolve(false);
				}
				this.dialog = false;
			},
			upgrade() {
				this.close();
				this.$emit("upgrade");
			},
		},
		computed: {
			subscriptionUrl() {
				if (this.organizationId) {
					return `/subscriptions/${this.organizationId}`;
				} else {
					return "";
				}
			},
			trialDays() {
				if (this.trialDaysRemaining != 1) {
					let days = this.trialDaysRemaining;

					if (days < 0) {
						days = 0;
					}

					return `${days} days`;
				} else {
					return "1 day";
				}
			},
			trialExpired() {
				return this.subscription?.accountStatus === constants.SUBSCRIPTION_STATUS.TRIAL_EXPIRED;
			},
		},
	};
</script>
<style scoped>
	.upgrade-overlay-mobile {
		background-color: white;
	}

	.upgrade-overlay-mobile::v-deep > .v-overlay__scrim {
		background-color: white !important;
	}

	.close-button {
		position: fixed !important;
		top: 16px;
		right: 16px;
		z-index: 10011;
	}

	.text-black {
		color: black;
	}

	a {
		text-decoration: underline;
	}

	.upgrade-message {
		word-break: break-word;
		margin-bottom: 0 !important;
	}
</style>
